"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PROPS_TITLES = exports.PropsTitlesDict = void 0;

var props_id_1 = require("./entities/props-id");

var PropsTitlesDict =
/** @class */
function () {
  function PropsTitlesDict() {
    this._titleDict = {};
    this.setTitle(props_id_1.PropsId.properties, 'Properties');
    this.setTitle(props_id_1.PropsId.config, 'Config');
    this.setTitle(props_id_1.PropsId.labels, 'Labels');
    this.setTitle(props_id_1.PropsId.annotations, 'Annotations');
    this.setTitle(props_id_1.PropsId.targetLinks, 'Links');
    this.setTitle(props_id_1.PropsId.env, 'Environment Variables');
    this.setTitle(props_id_1.PropsId.resources, 'Resources');
    this.setTitle(props_id_1.PropsId.resourcesPerPod, 'Resources Per Pod');
    this.setTitle(props_id_1.PropsId.nodeResources, 'Node Resources');
    this.setTitle(props_id_1.PropsId.poolResources, 'Pool Resources');
    this.setTitle(props_id_1.PropsId.clusterConsumption, 'Cluster Consumption');
    this.setTitle(props_id_1.PropsId.clusterResources, 'Cluster Resources');
    this.setTitle(props_id_1.PropsId.appConsumption, 'Application Consumption');
    this.setTitle(props_id_1.PropsId.resourceRoleMatrix, 'Resource Role Matrix');
    this.setTitle(props_id_1.PropsId.sharedWith, 'Shared With');
    this.setTitle(props_id_1.PropsId.usedBy, 'Used By');
    this.setTitle(props_id_1.PropsId.ingressApp, 'Ingress Application Rules');
    this.setTitle(props_id_1.PropsId.ingressCidr, 'Ingress CIDR Rules');
    this.setTitle(props_id_1.PropsId.egressApp, 'Egress Application Rules');
    this.setTitle(props_id_1.PropsId.egressCidr, 'Egress CIDR Rules');
    this.setTitle(props_id_1.PropsId.targetLinks, 'Target Links');
    this.setTitle(props_id_1.PropsId.radioactive, 'Radioactivity');
    this.setTitle(props_id_1.PropsId.contents, 'Contents');
    this.setTitle(props_id_1.PropsId.mount, 'Mount Config');
    this.setTitle(props_id_1.PropsId.health, 'Health');
    this.setTitle(props_id_1.PropsId.podStages, 'Pod Stages and Health'); // Summary

    this.setTitle(props_id_1.PropsId.appCounters, 'Configuration Summary');
    this.setTitle(props_id_1.PropsId.infraCounters, 'Infrastructure Summary');
    this.setTitle(props_id_1.PropsId.topIssueNamespaces, 'Top Namespaces with Issues');
    this.setTitle(props_id_1.PropsId.topIssues, 'Top Issues'); // Rules

    this.setTitle(props_id_1.PropsId.ruleAssistant, 'Rule Assistant');
  }

  PropsTitlesDict.prototype.setTitle = function (key, value) {
    this._titleDict[key] = value;
  };

  PropsTitlesDict.prototype.get = function (id) {
    var value = this._titleDict[id];

    if (value) {
      return value;
    }

    console.error("[PropsTitlesDict] Could not resolve value for: %s", id); // throw new Error("Could not resolve value for: " + id);

    return id.toString();
  };

  return PropsTitlesDict;
}();

exports.PropsTitlesDict = PropsTitlesDict;
exports.PROPS_TITLES = new PropsTitlesDict();